import { makeStyles } from 'tss-react/mui';

export default makeStyles()(({ spacing }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  picture: {
    width: '100%',
    height: spacing(33),
    borderRadius: spacing(2),
  },
  nameCtn: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  ratingCtn: {
    display: 'flex',
    alignItems: 'end',
    flexDirection: 'column',
  },
  priceBtnCtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  cardBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(1),
    padding: spacing(2, 1.5),
  },
}));
